import { create } from 'zustand';
import { bootstrap, logout } from '../service/user';
// import { Mixpanel } from "@jen-ui/lib";

export enum UserPermissionsEnum {
  Novice = 'base',
  Dabbler = 'dabbler',
  Soloist = 'soloist',
  Pro = 'pro',
}

export type UserPermissionsType = {
  code: string;
  details: { [key: string]: string };
};

export interface SessionType {
  user: {
    id: string;
    email: string;
    name: string;
    profile_image: string;
    role: string;
    credit: {
      value: number;
      monthly_credit: number;
    };
    permissions: UserPermissionsType[];
    plan: {
      key: string;
      name: string;
      price?: number;
      desc?: string;
    };
  };
  expires_at: undefined;
  token: string;
  isLoaded: boolean;
  artist?: {
    id: string;
    name: string;
    description: string;
  };
}

const initialSession = {
  user: {
    id: '',
    email: '',
    name: '',
    profile_image: '',
    role: '',
    credit: {
      value: 0,
      monthly_credit: 0,
    },
    permissions: [],
    plan: {
      key: '',
      name: '',
      price: 0,
      desc: '',
    },
  },
  expires_at: undefined,
  token: '',
  isLoaded: false,
  artist: {
    id: '',
    name: '',
    description: '',
  },
} as SessionType;

export interface SessionStore {
  session: SessionType;
  setSession: (session: SessionType) => void;
  logout: () => Promise<void>;
  fetchData: () => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
  session: initialSession,
  setSession: (session) => set({ session }),
  logout: async () => {
    await logout();
    set({ session: initialSession });
  },
  fetchData: async () => {
    try {
      const userInfo = (await bootstrap()) as any;
      if (!userInfo) {
        set({ session: { ...initialSession, isLoaded: true } });
      } else {
        const { access_token, email, expires_at, id, profile_image, name, plan, role, credit, permissions } = userInfo;
        // Mixpanel.identify(id, { name });
        set({
          session: {
            user: { id, email, name, profile_image, role, credit, permissions, plan },
            artist: { id: userInfo?.artist?.id, name: userInfo?.artist?.name, description: userInfo?.artist?.description },
            expires_at,
            token: access_token,
            isLoaded: true,
          },
        });
      }
    } catch (error) {
      set({ session: { ...initialSession, isLoaded: true } });
      console.error('Error fetching user info:', error);
    }
  },
}));
